import qs from 'qs';
import _ from 'lodash';

export const getQueryParam = (paramName, defaultValue = '') => {
  if (_.isEmpty(paramName)) return defaultValue;

  const queryString = window.location.search;
  const parsedQuery = qs.parse(queryString, { ignoreQueryPrefix: true, parseBooleans: true });

  return _.get(parsedQuery, paramName, defaultValue);
};
